import { WorkflowActivityModel } from "../../../models/workflow/workflow.models";
import { WorkflowConfigurationService } from "../../../services/workflow/workflow-configuration-service";

export class BaseActivityConfiguration {

    item: WorkflowActivityModel;
    meta: any;
    entity: string;
    branchId: string;

    constructor(protected workflowConfigurationService: WorkflowConfigurationService) { }

    activate(model: { activity: WorkflowActivityModel, entity: string, branchId: string }) {
        if (!model) {
            return;
        }
        this.branchId = model.branchId;
        this.item = model.activity;
        this.meta = model.activity.meta ? JSON.parse(model.activity.meta) : {};
        this.entity = model.entity;
        this.onActivated();
    }

    deactivate() {
        this.item = null;
        this.meta = null;
        this.entity = null;
    }

    onActivated() { }

    setMeta(): Promise<void> {
        return new Promise<void>((resolve) => {
            this.item.meta = JSON.stringify(this.meta);
            resolve();
        });
    }
}
